module.exports = __webpack_public_path__ + "media/images/sponsor/concept-award@2x-4bc66eef22e08a766b9195efbb969acf.png";